module.exports = __webpack_public_path__ + "static/media/ENDCAPPLAINENDFOR69 X.d595ea61.jpg";